// extracted by mini-css-extract-plugin
export var deleteModal = "_q6-0";